import { useArtworkForm, useEnsureAllPlacementSizes } from "@design-lab/entities/artwork";
import { useSignInModalInit } from "@design-lab/features/sign-in-modal";
import { useDtfChannel } from "@design-lab/shared/hooks/useDtfChannel";
import { useResponsive } from "@design-lab/shared/hooks/useResponsive";
import { useWebSocketTracking } from "@design-lab/shared/hooks/useWebSocketTracking";
import { trackTabNavigation } from "@design-lab/shared/lib/analytics";
import type { Tab } from "@design-lab/shared/types/tab";
import { useTab } from "@design-lab/shared/ui/layouts/state";
import { DesignLabDesktop } from "./DesignLabDesktop";
import { DesignLabMobile } from "./DesignLabMobile";

export function DesignLabPage() {
  const { isDesktop } = useResponsive();
  const { form } = useArtworkForm();
  const { isConnected } = useDtfChannel();

  useWebSocketTracking({ isConnected, artworkForm: form });
  useSignInModalInit();
  useEnsureAllPlacementSizes();

  const { tab, tabs, setTab } = useTab();

  const handleTabClick = (value: Tab) => {
    trackTabNavigation(value, "tabs");
    setTab(value);
  };

  const props = {
    handleTabClick,
    tabs,
    tab,
    setTab
  };

  return isDesktop ? <DesignLabDesktop {...props} /> : <DesignLabMobile {...props} />;
}
